
import { defineComponent, PropType, computed } from "vue";
import Multiselect from "@vueform/multiselect";
import { Field, ErrorMessage } from "vee-validate";

export default defineComponent({
  name: "SelectInput",
  components: { Multiselect, Field, ErrorMessage },
  props: {
    input: { type: Object as PropType<any>, required: true },
    options: { type: Array as PropType<any[]>, default: () => [] },
    mode: { type: String as PropType<"relationships" | "custom" | "array">, required: true },
    modelValue: { type: [String, Number, Array], default: null },
    disabled: { type: Boolean, default: false },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const labelProp = computed(() => props.input.multiSelectLabel || "name");
    const byId = computed(() => {
      return Object.fromEntries((props.options || []).map((option) => [option.id, option]));
    });
    const model = computed({
      get: () => props.modelValue,
      set: (v) => emit("update:modelValue", v),
    });
    const multipleLabel = (values: unknown) => {
      if (!Array.isArray(values)) return "";
      const names = values
        .map((value) => {
          if (value && typeof value === "object") {
            const label = (value as Record<string, unknown>)[labelProp.value];
            return typeof label === "string" ? label : "";
          }
          return byId.value[value as keyof typeof byId.value]?.[labelProp.value] ?? "";
        })
        .filter((name) => name);
      return names.length ? names.join(", ") : `${values.length} options selected`;
    };
    return { model, labelProp, multipleLabel };
  },
});
